/**
 * @generated SignedSource<<4ec1cbd2860a2bab2ff594a20a824295>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "RefundImpulseResponse",
    "kind": "LinkedField",
    "name": "refundImpulse",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationRefundImpulseImplMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationRefundImpulseImplMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "998cd3dbac0f075b2b90facac1256984",
    "id": null,
    "metadata": {},
    "name": "IntegrationRefundImpulseImplMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationRefundImpulseImplMutation(\n  $request: RefundImpulseRequestInput\n) {\n  refundImpulse(request: $request) {\n    status\n  }\n}\n"
  }
};
})();

node.hash = "0d0df1d44c2796ffeb6f8ba5eadd37ae";

module.exports = node;
